// extracted by mini-css-extract-plugin
module.exports = {"how-it-works":"_16aVEb2NNA_QveKoyCrTew","howItWorks":"_16aVEb2NNA_QveKoyCrTew"};